export default "__VITE_ASSET__2004e9fd__"